module.exports = __webpack_public_path__ + "img/康熙题字详情.5e79ccae.jpg";